import { IIndexInfoAvailable } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { useInternalMode } from "@rentiohq/web-shared/dist/redux/system/system.hooks";
import React from "react";
import { getIndexInfoForInternalMode } from "./Index.utils";
import * as S from "./IndexInternalInfo.styles";

interface IProps {
  indexInfoAvailable: IIndexInfoAvailable;
}

export const IndexInternalInfo = (props: IProps) => {
  const { indexInfoAvailable } = props;

  const { internalModeEnabled } = useInternalMode();
  const [showAll, setShowAll] = React.useState(false);

  if (!internalModeEnabled) {
    return null;
  }

  const mainItems = Object.entries(
    getIndexInfoForInternalMode(indexInfoAvailable),
  );

  const additionalItems: [string, any][] = (
    indexInfoAvailable.additionalCosts ?? []
  ).flatMap(cost => [
    [
      `Additional Cost:${cost.description} - New price & increase`,
      `${cost.newPrice} | ${cost.increase}`,
    ],
    [
      `Additional Cost:${cost.description} - New price & increase - EPC D`,
      `${cost.newPriceEpcD} | ${cost.increaseEpcD}`,
    ],
    [
      `Additional Cost:${cost.description} - New price & increase - EPC E`,
      `${cost.newPriceEpcE} | ${cost.increaseEpcE}`,
    ],
    [
      `Additional Cost:${cost.description} - New price & increase - EPC F`,
      `${cost.newPriceEpcF} | ${cost.increaseEpcF}`,
    ],
    [
      `Additional Cost:${cost.description} - New price & increase - EPC G`,
      `${cost.newPriceEpcG} | ${cost.increaseEpcG}`,
    ],
    [
      `Additional Cost:${cost.description} - New price & increase - NO EPC`,
      `${cost.newPriceNoEpc} | ${cost.increaseNoEpc}`,
    ],
  ]);

  const allItems: [string, any][] = [...mainItems, ...additionalItems];
  const visibleCount = Math.max(1, Math.ceil(allItems.length * 0.2));
  const visibleItems = showAll ? allItems : allItems.slice(0, visibleCount);
  const hasMore = allItems.length > visibleCount;

  return (
    <S.Wrap>
      {visibleItems.map(([key, value]) => (
        <div key={key}>
          <b>{key}</b>:{" "}
          {value !== undefined && value !== null ? `${value}` : "-"}
        </div>
      ))}

      {hasMore && (
        <S.SeeMoreButton onClick={() => setShowAll(prev => !prev)}>
          {showAll
            ? "See less ▲"
            : `See more ▼ (${allItems.length - visibleCount} more)`}
        </S.SeeMoreButton>
      )}
    </S.Wrap>
  );
};
